import Rest from '@services/Rest'

/**
 * criado para aceitar ou recusar solicitações de reembolso/fechamento de reclamações no erp
 * @typedef {ErpService}
 */
export default class ErpService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/erp'
}
